<div class="svg-container" [innerHTML]="svgContent | async"></div>
